// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentDocumentModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentDocumentModel.attributeTypeMap;
    }
}
ExtEnrollmentDocumentModel.discriminator = undefined;
ExtEnrollmentDocumentModel.additionalProperties = false;
ExtEnrollmentDocumentModel.attributeTypeMap = [
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "documentCreateDate",
        "baseName": "documentCreateDate",
        "type": "string"
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "string"
    },
    {
        "name": "documentName",
        "baseName": "documentName",
        "type": "string"
    },
    {
        "name": "documentStatus",
        "baseName": "documentStatus",
        "type": "string"
    },
    {
        "name": "claimId",
        "baseName": "claimId",
        "type": "string"
    },
    {
        "name": "claimCreateDate",
        "baseName": "claimCreateDate",
        "type": "string"
    },
    {
        "name": "claimStatus",
        "baseName": "claimStatus",
        "type": "string"
    },
    {
        "name": "dateOfService",
        "baseName": "dateOfService",
        "type": "string"
    },
    {
        "name": "regretReasons",
        "baseName": "regretReasons",
        "type": ""
    },
];
//# sourceMappingURL=extEnrollmentDocumentModel.js.map